export const REST_API_CLASSIC_AUTHORIZATION_DOCUMENTATION_MARKDOWN = `
##  Rest API Notable Classic Auth

Notable already stores many of the credentials necessary for making authenticated calls. 
Choose from the existing credentials to automatically authenticate your requests
`;
